import { render, staticRenderFns } from "./r1_v.vue?vue&type=template&id=787af9d4&scoped=true&"
import script from "./r1_v.vue?vue&type=script&lang=js&"
export * from "./r1_v.vue?vue&type=script&lang=js&"
import style0 from "./r1_v.vue?vue&type=style&index=0&id=787af9d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787af9d4",
  null
  
)

export default component.exports